var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "webstore-container" } },
    [
      _c("CheckoutHeader", {
        attrs: {
          checkoutStep: { display: true, step: 1 },
          categoryFilter: {
            display: _vm.activePage === "products",
            all:
              _vm.webstoreContent.categoriesInfo &&
              _vm.webstoreContent.categoriesInfo["All"]["category"],
            devices:
              _vm.webstoreContent.categoriesInfo &&
              _vm.webstoreContent.categoriesInfo["Devices"]["category"],
            accessories:
              _vm.webstoreContent.categoriesInfo &&
              _vm.webstoreContent.categoriesInfo["Accessories"]["category"],
          },
          enableTalkToSales: this.shouldButtonShowBasedOnDate,
          showTalkToSales: this.showTalkToSalesButton,
          shoppingBag: { display: true },
          stickyOverwrite: _vm.activePage !== "products",
          productCatalogPage: _vm.activePage === "products",
        },
        on: {
          "anonymous-inquiry": function ($event) {
            _vm.anonymousInquiryModal = true
          },
        },
      }),
      _vm._v(" "),
      _vm.displayLoader
        ? _c("LoadingScreen")
        : _c(
            "div",
            [
              _vm.activePage === "products"
                ? _c("ProductCatalog", {
                    attrs: {
                      webstoreProductContent: _vm.webstoreProductContent,
                    },
                    on: {
                      "inquire-modal": _vm.openInquiryModal,
                      "anonymous-modal": function ($event) {
                        _vm.anonymousInquiryModal = true
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activePage === "addProduct"
                ? _c("AddProduct", {
                    key: _vm.activeProductKey,
                    attrs: {
                      webstoreProductContent: _vm.webstoreProductContent,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.activePage === "addAccessory"
                ? _c("AddAccessory", {
                    key: _vm.activeProductKey,
                    on: {
                      "anonymous-inquiry": function ($event) {
                        _vm.anonymousInquiryModal = true
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("InquireModal", {
                attrs: {
                  isOpen: _vm.inquireModalIsOpen,
                  productName: _vm.inquiryName,
                  productKey: _vm.inquiryKey,
                  homePage: "true",
                },
                on: {
                  "hide-modal": function ($event) {
                    _vm.inquireModalIsOpen = false
                  },
                },
              }),
              _vm._v(" "),
              _vm.anonymousInquiryModal
                ? _c("AnonymousInquiryModal", {
                    on: {
                      "hide-modal": function ($event) {
                        _vm.anonymousInquiryModal = false
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ShoppingCart"),
              _vm._v(" "),
              _c("WebstoreFooter"),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }